import React from 'react';
import { cn } from '../../lib/utils';
import { Settings2, X, Sparkles, Activity, Orbit, RotateCcw, Lock, Unlock } from 'lucide-react';
import { ToggleSwitch } from '../ui/ToggleSwitch';

export interface SettingsSidebarProps { [key: string]: any; }

export const SettingsSidebar: React.FC<SettingsSidebarProps> = ({
  showMobileSettings,
  setShowMobileSettings,
  isAdmin,
  activeSettingsTab,
  setActiveSettingsTab,
  setSaveMessage,
  saveMessage,

  leadName,
  setLeadName,
  leadEmail,
  setLeadEmail,
  leadPhone,
  setLeadPhone,
  leadCompany,
  setLeadCompany,
  leadDetails,
  setLeadDetails,
  isSubmittingLead,
  leadSuccessMsg,
  setLeadSuccessMsg,
  submitLead,

  useRealData,
  setUseRealData,
  isLoadingData,
  dataError,

  controlRotateSpeed,
  setControlRotateSpeed,
  controlPanSpeed,
  setControlPanSpeed,
  controlZoomSpeed,
  setControlZoomSpeed,

  colorUp,
  setColorUp,
  colorDown,
  setColorDown,
  show3D,
  setShow3D,
  colorIntensity,
  setColorIntensity,
  main3DOpacity,
  setMain3DOpacity,
  showShadowFloor,
  setShowShadowFloor,
  floorChartOpacity,
  setFloorChartOpacity,
  floorChartLineWidth,
  setFloorChartLineWidth,
  showShadowSide,
  setShowShadowSide,
  sideChartOpacity,
  setSideChartOpacity,
  sideChartLineWidth,
  setSideChartLineWidth,
  backwallStyle,
  setBackwallStyle,
  backChartOpacity,
  setBackChartOpacity,
  showMidLineWall,
  setShowMidLineWall,
  midLineWallColor,
  setMidLineWallColor,
  midLineWallOpacity,
  setMidLineWallOpacity,
  showGrid,
  setShowGrid,
  gridColor,
  setGridColor,
  gridOpacity,
  setGridOpacity,
  gridThickness,
  setGridThickness,

  showSMA10,
  setShowSMA10,
  sma10Period,
  setSma10Period,
  showSMA20,
  setShowSMA20,
  sma20Period,
  setSma20Period,
  showSMA50,
  setShowSMA50,
  sma50Period,
  setSma50Period,
  showConnectors,
  setShowConnectors,
  connectorsOpacity,
  setConnectorsOpacity,
  connectorsThickness,
  setConnectorsThickness,
  showPeriodSeparators,
  setShowPeriodSeparators,
  periodColor,
  setPeriodColor,
  periodOpacity,
  setPeriodOpacity,
  showPeriodLabels,
  setShowPeriodLabels,

  lockedSliders,
  setLockedSliders,

  user,
  authToken,
  saveSettings,
  syncWorkspaceToCloud,
  loadWorkspaceFromCloud,
  resetSettings,
  isSaving,

}) => {
  if (!showMobileSettings) return null;

  return (
    <div 
      className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm transition-all duration-300 pointer-events-auto"
      onClick={() => setShowMobileSettings(false)}
    >
      <div 
        className="bg-[#060919]/90 backdrop-blur-xl border border-[#00d9ff]/30 p-5 md:p-6 rounded-2xl w-full max-w-[420px] max-h-[85vh] overflow-y-auto overflow-x-hidden transition-all duration-300 custom-scrollbar shadow-[0_0_50px_rgba(0,0,0,0.8)] animate-in fade-in zoom-in-95"
        onPointerDown={(e) => e.stopPropagation()}
        onPointerUp={(e) => e.stopPropagation()}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex justify-between items-center mb-4 sticky top-[-20px] md:top-[-24px] bg-[#060919] pt-5 md:pt-6 pb-3 -mx-5 md:-mx-6 px-5 md:px-6 z-10 border-b border-[#00d9ff]/20">
          <h2 
            className="text-[14px] font-bold uppercase tracking-[3px] text-[#00d9ff] flex items-center gap-2 select-none cursor-pointer"
            title="Configurações"
          >
            <Settings2 size={16} /> Configurações
          </h2>
          <button onClick={() => setShowMobileSettings(false)} className="text-[#00d9ff] p-1.5 bg-[#00d9ff]/10 rounded-full hover:bg-[#00d9ff]/20 transition-all"><X size={18} /></button>
        </div>

        {/* Tabs Selector */}
        <div className="flex flex-wrap justify-center gap-1 mb-5 border-b border-[#00d9ff]/10 pb-3 sticky top-[48px] bg-[#060919] z-10">
          {isAdmin && (
            <button
              onClick={() => setActiveSettingsTab('dados')}
              className={cn(
                "px-2 py-1.5 rounded-lg text-[9px] uppercase tracking-[1.5px] transition-all font-mono text-center truncate cursor-pointer",
                activeSettingsTab === 'dados'
                  ? "bg-[#00d9ff]/20 text-[#00d9ff] font-bold border border-[#00d9ff]/30 shadow-[0_0_8px_rgba(0,217,255,0.2)]"
                  : "text-[#666666] hover:text-[#00d9ff] border border-transparent"
              )}
            >
              Simulação
            </button>
          )}
          <button
            onClick={() => setActiveSettingsTab('visual')}
            className={cn(
              "px-3 py-1.5 rounded-lg text-[9px] uppercase tracking-[3px] transition-all font-mono text-center truncate cursor-pointer",
              activeSettingsTab === 'visual'
                ? "bg-[#00d9ff]/20 text-[#00d9ff] font-bold border border-[#00d9ff]/30 shadow-[0_0_8px_rgba(0,217,255,0.2)]"
                : "text-[#666666] hover:text-[#00d9ff] border border-transparent"
            )}
          >
            VISUAL IDENTITY
          </button>
          <button
            onClick={() => setActiveSettingsTab('controles')}
            className={cn(
              "px-3 py-1.5 rounded-lg text-[9px] uppercase tracking-[3px] transition-all font-mono text-center truncate cursor-pointer",
              activeSettingsTab === 'controles'
                ? "bg-[#00d9ff]/20 text-[#00d9ff] font-bold border border-[#00d9ff]/30 shadow-[0_0_8px_rgba(0,217,255,0.2)]"
                : "text-[#666666] hover:text-[#00d9ff] border border-transparent"
            )}
          >
            CONTROLES
          </button>
          <button
            onClick={() => setActiveSettingsTab('estudos')}
            className={cn(
              "px-3 py-1.5 rounded-lg text-[9px] uppercase tracking-[3px] transition-all font-mono text-center truncate cursor-pointer",
              activeSettingsTab === 'estudos'
                ? "bg-[#00d9ff]/20 text-[#00d9ff] font-bold border border-[#00d9ff]/30 shadow-[0_0_8px_rgba(0,217,255,0.2)]"
                : "text-[#666666] hover:text-[#00d9ff] border border-transparent"
            )}
          >
            CHART TOOLS
          </button>
          {isAdmin && (
            <button
              onClick={() => setActiveSettingsTab('nuvem')}
              className={cn(
                "px-2 py-1.5 rounded-lg text-[9px] uppercase tracking-[1.5px] transition-all font-mono text-center truncate cursor-pointer",
                activeSettingsTab === 'nuvem'
                  ? "bg-[#00d9ff]/20 text-[#00d9ff] font-bold border border-[#00d9ff]/30 shadow-[0_0_8px_rgba(0,217,255,0.2)]"
                  : "text-[#666666] hover:text-[#00d9ff] border border-transparent"
              )}
            >
              Nuvem
            </button>
          )}
          {!isAdmin && (
            <button
              onClick={() => setActiveSettingsTab('vip')}
              className={cn(
                "px-2 py-1.5 rounded-lg text-[9px] uppercase tracking-[1.5px] transition-all font-mono text-center truncate cursor-pointer",
                activeSettingsTab === 'vip'
                  ? "bg-[#cc00ff]/20 text-[#cc00ff] font-bold border border-[#cc00ff]/30 shadow-[0_0_8px_rgba(204,0,255,0.2)]"
                  : "text-[#666666] hover:text-[#cc00ff] border border-transparent"
              )}
            >
              VIP
            </button>
          )}
        </div>

        <div className="space-y-6">
          {/* TAB: VIP (CLIENTS LEAD CAPTURE FORM) */}
          {!isAdmin && activeSettingsTab === 'vip' && (
            <div className="space-y-4 animate-in fade-in slide-in-from-bottom-2 duration-200">
              <div className="space-y-3">
                <h2 className="text-[10px] md:text-[11px] uppercase tracking-[2px] text-[#cc00ff] border-b border-[#cc00ff]/20 pb-1 flex justify-between items-center">
                  Assinatura de Sinais VIP
                  <Sparkles size={12} className="text-[#cc00ff] animate-pulse" />
                </h2>
                <p className="text-[9px] text-[#888] leading-relaxed text-left">
                  Cadastre seu contato para ingressar na lista de distribuição exclusiva. Receba alertas de ressonância 3D extrema, relatórios fractais de momentum e análises premium do motor <span className="text-[#cc00ff] font-bold">FLOWAES</span> diretamente no seu celular/email.
                </p>

                {leadSuccessMsg ? (
                  <div className="bg-[#cc00ff]/10 border border-[#cc00ff]/40 p-4 rounded-lg text-center space-y-2 animate-in zoom-in-95 duration-200">
                    <Sparkles className="w-8 h-8 mx-auto text-[#cc00ff]" />
                    <p className="text-[11px] text-[#cc00ff] font-bold uppercase tracking-[1px]">Cadastro Confirmado</p>
                    <p className="text-[10px] text-[#e0e0e0] leading-relaxed">{leadSuccessMsg}</p>
                    <button 
                      onClick={() => setLeadSuccessMsg(null)}
                      className="mt-2 text-[8px] uppercase tracking-[1px] text-[#cc00ff]/60 hover:text-[#cc00ff] underline cursor-pointer"
                    >
                      Fazer outro cadastro
                    </button>
                  </div>
                ) : (
                  <form onSubmit={submitLead} className="space-y-2.5 font-mono text-left">
                    <div className="space-y-1">
                      <label className="text-[8px] text-[#666] uppercase tracking-[1px] flex justify-between">
                        <span>Nome Completo *</span>
                      </label>
                      <input 
                        type="text" 
                        required
                        placeholder="Ex: João Silva"
                        value={leadName}
                        onChange={(e) => setLeadName(e.target.value)}
                        className="w-full bg-[#03050f]/80 border border-[#cc00ff]/20 rounded px-2.5 py-1.5 text-[10px] text-[#e0e0e0] focus:outline-none focus:border-[#cc00ff]/60"
                      />
                    </div>

                    <div className="grid grid-cols-2 gap-2">
                      <div className="space-y-1">
                        <label className="text-[8px] text-[#666] uppercase tracking-[1px]">E-mail *</label>
                        <input 
                          type="email" 
                          required
                          placeholder="joao@empresa.com"
                          value={leadEmail}
                          onChange={(e) => setLeadEmail(e.target.value)}
                          className="w-full bg-[#03050f]/80 border border-[#cc00ff]/20 rounded px-2.5 py-1.5 text-[10px] text-[#e0e0e0] focus:outline-none focus:border-[#cc00ff]/60"
                        />
                      </div>
                      <div className="space-y-1">
                        <label className="text-[8px] text-[#666] uppercase tracking-[1px]">WhatsApp/Fone *</label>
                        <input 
                          type="tel" 
                          required
                          placeholder="(11) 99999-9999"
                          value={leadPhone}
                          onChange={(e) => setLeadPhone(e.target.value)}
                          className="w-full bg-[#03050f]/80 border border-[#cc00ff]/20 rounded px-2.5 py-1.5 text-[10px] text-[#e0e0e0] focus:outline-none focus:border-[#cc00ff]/60"
                        />
                      </div>
                    </div>

                    <div className="space-y-1">
                      <label className="text-[8px] text-[#666] uppercase tracking-[1px]">Empresa (Opcional)</label>
                      <input 
                        type="text" 
                        placeholder="Nome da sua corretora ou empresa"
                        value={leadCompany}
                        onChange={(e) => setLeadCompany(e.target.value)}
                        className="w-full bg-[#03050f]/80 border border-[#cc00ff]/20 rounded px-2.5 py-1.5 text-[10px] text-[#e0e0e0] focus:outline-none focus:border-[#cc00ff]/60"
                      />
                    </div>

                    <div className="space-y-1">
                      <label className="text-[8px] text-[#666] uppercase tracking-[1px]">Mensagem / Ativos de Interesse (Opcional)</label>
                      <textarea 
                        rows={2}
                        placeholder="Ex: Tenho interesse em receber relatórios sobre BTCUSDT."
                        value={leadDetails}
                        onChange={(e) => setLeadDetails(e.target.value)}
                        className="w-full bg-[#03050f]/80 border border-[#cc00ff]/20 rounded px-2.5 py-1.5 text-[10px] text-[#e0e0e0] focus:outline-none focus:border-[#cc00ff]/60 resize-none"
                      />
                    </div>

                    <button
                      type="submit"
                      disabled={isSubmittingLead}
                      className="w-full bg-gradient-to-r from-[#cc00ff] to-[#7b00ff] hover:opacity-90 active:scale-98 text-white text-[10px] uppercase font-bold py-2 rounded-lg transition-all duration-200 mt-2 tracking-[2px] flex items-center justify-center gap-2 shadow-[0_0_15px_rgba(204,0,255,0.3)] cursor-pointer"
                    >
                      {isSubmittingLead ? (
                        <Activity className="w-3.5 h-3.5 animate-spin" />
                      ) : (
                        <>
                          <Sparkles size={12} /> Solicitar Acesso Exclusivo
                        </>
                      )}
                    </button>
                  </form>
                )}
              </div>
            </div>
          )}

          {/* TAB: DADOS (ADMIN ONLY) */}
          {isAdmin && activeSettingsTab === 'dados' && (
            <div className="space-y-4 animate-in fade-in slide-in-from-bottom-2 duration-200">
              <div className="space-y-3">
                <h2 className="text-[10px] md:text-[11px] uppercase tracking-[2px] text-[#00d9ff] border-b border-[#00d9ff]/20 pb-1">Fonte de Dados (Simulador)</h2>
                <div className="flex justify-between items-center bg-[#0a0e27]/50 border border-[#00d9ff]/30 p-1 rounded-full">
                  <button
                    onClick={() => setUseRealData(false)}
                    className={cn(
                      "flex-1 py-1.5 rounded-full text-[10px] uppercase tracking-[1px] transition-all duration-200 cursor-pointer",
                      !useRealData ? "bg-[#00d9ff]/20 text-[#00d9ff] font-bold" : "text-[#666666] hover:text-[#00d9ff]"
                    )}
                  >
                    Simulado
                  </button>
                  <button
                    onClick={() => setUseRealData(true)}
                    className={cn(
                      "flex-1 py-1.5 rounded-full text-[10px] uppercase tracking-[1px] transition-all duration-200 flex items-center justify-center gap-2 cursor-pointer",
                      useRealData ? "bg-[#00ff88]/20 text-[#00ff88] font-bold" : "text-[#666666] hover:text-[#00ff88]"
                    )}
                  >
                    Real
                    {useRealData && !isLoadingData && !dataError && (
                      <span className="w-1.5 h-1.5 bg-[#00ff88] rounded-full animate-pulse shadow-[0_0_5px_#00ff88]"></span>
                    )}
                  </button>
                </div>
              </div>
            </div>
          )}

          {/* TAB: CONTROLES */}
          {activeSettingsTab === 'controles' && (
            <div className="space-y-4 animate-in fade-in slide-in-from-right-4 duration-300">
              <div className="border border-white/5 bg-[#0a0e27]/50 rounded-lg p-3 shadow-inner">
                <h3 className="text-[11px] font-bold uppercase tracking-[2px] text-[#00d9ff] mb-4 flex items-center gap-2">
                  <Orbit size={14} /> Sensibilidade de Navegação (Mouse/Touch)
                </h3>
                
                <div className="space-y-5">
                  <div className="space-y-1">
                    <div className="flex justify-between items-center">
                      <span className="text-[9px] uppercase font-bold text-[#666666] tracking-[1px]">Rotação (Orbit)</span>
                      <span className="text-[10px] text-[#00d9ff] font-bold">{Number(controlRotateSpeed || 1).toFixed(2)}x</span>
                    </div>
                    <input 
                      type="range" 
                      min="0.1" 
                      max="3.0" 
                      step="0.1" 
                      value={controlRotateSpeed}
                      onChange={(e) => setControlRotateSpeed(parseFloat(e.target.value))}
                      className="w-full accent-[#00d9ff] h-1 bg-[#1a1f3c] rounded-full appearance-none [&::-webkit-slider-thumb]:appearance-none [&::-webkit-slider-thumb]:w-3 [&::-webkit-slider-thumb]:h-3 [&::-webkit-slider-thumb]:bg-[#00d9ff] [&::-webkit-slider-thumb]:rounded-full cursor-pointer"
                    />
                  </div>
                  
                  <div className="space-y-1">
                    <div className="flex justify-between items-center">
                      <span className="text-[9px] uppercase font-bold text-[#666666] tracking-[1px]">Movimento (Pan/Arrasto)</span>
                      <span className="text-[10px] text-[#00d9ff] font-bold">{Number(controlPanSpeed || 1).toFixed(2)}x</span>
                    </div>
                    <input 
                      type="range" 
                      min="0.1" 
                      max="5.0" 
                      step="0.1" 
                      value={controlPanSpeed}
                      onChange={(e) => setControlPanSpeed(parseFloat(e.target.value))}
                      className="w-full accent-[#00d9ff] h-1 bg-[#1a1f3c] rounded-full appearance-none [&::-webkit-slider-thumb]:appearance-none [&::-webkit-slider-thumb]:w-3 [&::-webkit-slider-thumb]:h-3 [&::-webkit-slider-thumb]:bg-[#00d9ff] [&::-webkit-slider-thumb]:rounded-full cursor-pointer"
                    />
                  </div>

                  <div className="space-y-1">
                    <div className="flex justify-between items-center">
                      <span className="text-[9px] uppercase font-bold text-[#666666] tracking-[1px]">Aproximação (Zoom)</span>
                      <span className="text-[10px] text-[#00d9ff] font-bold">{Number(controlZoomSpeed || 1).toFixed(2)}x</span>
                    </div>
                    <input 
                      type="range" 
                      min="0.1" 
                      max="5.0" 
                      step="0.1" 
                      value={controlZoomSpeed}
                      onChange={(e) => setControlZoomSpeed(parseFloat(e.target.value))}
                      className="w-full accent-[#00d9ff] h-1 bg-[#1a1f3c] rounded-full appearance-none [&::-webkit-slider-thumb]:appearance-none [&::-webkit-slider-thumb]:w-3 [&::-webkit-slider-thumb]:h-3 [&::-webkit-slider-thumb]:bg-[#00d9ff] [&::-webkit-slider-thumb]:rounded-full cursor-pointer"
                    />
                  </div>
                  <div className="pt-2 border-t border-white/5">
                    <button
                      onClick={() => {
                        setControlRotateSpeed(0.5);
                        setControlPanSpeed(1.5);
                        setControlZoomSpeed(1.0);
                      }}
                      className="w-full text-center text-[9px] uppercase text-[#666666] hover:text-[#00d9ff] transition-colors py-2 flex items-center justify-center gap-1 cursor-pointer"
                    >
                      <RotateCcw size={10} /> Restaurar Padrões
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* TAB: VISUAL */}
          {activeSettingsTab === 'visual' && (
            <div className="space-y-4 animate-in fade-in slide-in-from-bottom-2 duration-200">
              <div className="space-y-3">
                <div className="space-y-3 mb-4">
                  <h2 className="text-[10px] uppercase tracking-[2px] text-[#00d9ff] border-b border-[#00d9ff]/20 pb-1">Cores da Tendência</h2>
                  <div className="grid grid-cols-2 gap-4">
                    <div className="flex flex-col gap-1">
                      <label className="text-[8px] uppercase text-[#666666] tracking-[1px]">Cor de Alta</label>
                      <div className="flex items-center gap-2">
                        <input 
                          type="color" 
                          value={colorUp} 
                          onChange={(e) => setColorUp(e.target.value)}
                          className="w-6 h-6 rounded cursor-pointer bg-transparent border-0 p-0"
                        />
                        <span className="text-[9px] text-[#00ffa3] uppercase">{colorUp}</span>
                      </div>
                    </div>
                    <div className="flex flex-col gap-1">
                      <label className="text-[8px] uppercase text-[#666666] tracking-[1px]">Cor de Baixa</label>
                      <div className="flex items-center gap-2">
                        <input 
                          type="color" 
                          value={colorDown} 
                          onChange={(e) => setColorDown(e.target.value)}
                          className="w-6 h-6 rounded cursor-pointer bg-transparent border-0 p-0"
                        />
                        <span className="text-[9px] text-[#ff3d67] uppercase">{colorDown}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <h2 className="text-[10px] md:text-[11px] uppercase tracking-[2px] text-[#00d9ff] border-b border-[#00d9ff]/20 pb-1">Identidade Visual</h2>
                
                <div className="border border-white/5 bg-[#0a0e27]/50 rounded-lg p-3 mb-4 shadow-inner">
                  <div className="flex justify-between items-center">
                    <div className="flex-1 mr-2">
                      <ToggleSwitch checked={show3D} onChange={setShow3D} label="Gráfico 3D (3D Line)" disabled={lockedSliders['box_3d'] ?? false} />
                    </div>
                    <button onClick={(e) => { e.stopPropagation(); setLockedSliders((p: any) => ({...p, ['box_3d']: !(p['box_3d'] ?? false)})) }} className="text-[#00d9ff]/50 hover:text-[#00d9ff] focus:outline-none transition-all cursor-pointer">
                      {(lockedSliders['box_3d'] ?? false) ? <Lock size={14} /> : <Unlock size={14} />}
                    </button>
                  </div>
                  {show3D && (
                    <div className={cn("mt-3 pt-3 border-t border-white/5 space-y-3 animate-in fade-in zoom-in duration-300", (lockedSliders['box_3d'] ?? false) && "opacity-50 pointer-events-none")}>
                      <div className="space-y-1">
                        <div className="flex justify-between items-center">
                          <span className="text-[8px] uppercase font-bold text-[#666666] tracking-[1px]">Brilho (Bloom)</span>
                          <span className="text-[10px] text-[#00d9ff] font-bold">{Number(colorIntensity || 1).toFixed(1)}x</span>
                        </div>
                        <input type="range" min="0.5" max="3" step="0.1" value={colorIntensity} onChange={(e) => setColorIntensity(parseFloat(e.target.value))} className="w-full h-1 bg-[#00d9ff]/20 rounded appearance-none cursor-pointer accent-[#00d9ff]" />
                      </div>
                      <div className="space-y-1">
                        <div className="flex justify-between items-center">
                          <span className="text-[8px] uppercase font-bold text-[#666666] tracking-[1px]">Opacidade Principal</span>
                          <span className="text-[10px] text-[#00d9ff] font-bold">{Math.round(main3DOpacity * 100)}%</span>
                        </div>
                        <input type="range" min="0" max="1" step="0.05" value={main3DOpacity} onChange={(e) => setMain3DOpacity(parseFloat(e.target.value))} className="w-full h-1 bg-[#00d9ff]/20 rounded appearance-none cursor-pointer accent-[#00d9ff]" />
                      </div>
                    </div>
                  )}
                </div>

                <div className="border border-white/5 bg-[#0a0e27]/50 rounded-lg p-3 mb-4 shadow-inner">
                  <div className="flex justify-between items-center">
                    <div className="flex-1 mr-2">
                      <ToggleSwitch checked={showShadowFloor} onChange={setShowShadowFloor} label="Gráfico de Chão" disabled={lockedSliders['box_floor'] ?? false} />
                    </div>
                    <button onClick={(e) => { e.stopPropagation(); setLockedSliders((p: any) => ({...p, ['box_floor']: !(p['box_floor'] ?? false)})) }} className="text-[#00d9ff]/50 hover:text-[#00d9ff] focus:outline-none transition-all cursor-pointer">
                      {(lockedSliders['box_floor'] ?? false) ? <Lock size={14} /> : <Unlock size={14} />}
                    </button>
                  </div>
                  {showShadowFloor && (
                    <div className={cn("mt-3 pt-3 border-t border-white/5 space-y-3 animate-in fade-in zoom-in duration-300", (lockedSliders['box_floor'] ?? false) && "opacity-50 pointer-events-none")}>
                      <div className="space-y-1">
                        <div className="flex justify-between items-center">
                          <span className="text-[8px] uppercase font-bold text-[#666666] tracking-[1px]">Opacidade</span>
                          <span className="text-[10px] text-[#00d9ff] font-bold">{Math.round(floorChartOpacity * 100)}%</span>
                        </div>
                        <input type="range" min="0" max="1" step="0.05" value={floorChartOpacity} onChange={(e) => setFloorChartOpacity(parseFloat(e.target.value))} className="w-full h-1 bg-[#00d9ff]/20 rounded appearance-none cursor-pointer accent-[#00d9ff]" />
                      </div>
                      <div className="space-y-1">
                        <div className="flex justify-between items-center">
                          <span className="text-[8px] uppercase font-bold text-[#666666] tracking-[1px]">Grossura</span>
                          <span className="text-[10px] text-[#00d9ff] font-bold">{Number(floorChartLineWidth || 1).toFixed(1)}px</span>
                        </div>
                        <input type="range" min="0.5" max="5" step="0.1" value={floorChartLineWidth} onChange={(e) => setFloorChartLineWidth(parseFloat(e.target.value))} className="w-full h-1 bg-[#00d9ff]/20 rounded appearance-none cursor-pointer accent-[#00d9ff]" />
                      </div>
                    </div>
                  )}
                </div>

                <div className="border border-white/5 bg-[#0a0e27]/50 rounded-lg p-3 mb-4 shadow-inner">
                  <div className="flex justify-between items-center">
                    <div className="flex-1 mr-2">
                      <ToggleSwitch checked={showShadowSide} onChange={setShowShadowSide} label="Gráfico Lateral" disabled={lockedSliders['box_side'] ?? false} />
                    </div>
                    <button onClick={(e) => { e.stopPropagation(); setLockedSliders((p: any) => ({...p, ['box_side']: !(p['box_side'] ?? false)})) }} className="text-[#00d9ff]/50 hover:text-[#00d9ff] focus:outline-none transition-all cursor-pointer">
                      {(lockedSliders['box_side'] ?? false) ? <Lock size={14} /> : <Unlock size={14} />}
                    </button>
                  </div>
                  {showShadowSide && (
                    <div className={cn("mt-3 pt-3 border-t border-white/5 space-y-3 animate-in fade-in zoom-in duration-300", (lockedSliders['box_side'] ?? false) && "opacity-50 pointer-events-none")}>
                      <div className="space-y-1">
                        <div className="flex justify-between items-center">
                          <span className="text-[8px] uppercase font-bold text-[#666666] tracking-[1px]">Opacidade</span>
                          <span className="text-[10px] text-[#00d9ff] font-bold">{Math.round(sideChartOpacity * 100)}%</span>
                        </div>
                        <input type="range" min="0" max="1" step="0.05" value={sideChartOpacity} onChange={(e) => setSideChartOpacity(parseFloat(e.target.value))} className="w-full h-1 bg-[#00d9ff]/20 rounded appearance-none cursor-pointer accent-[#00d9ff]" />
                      </div>
                      <div className="space-y-1">
                        <div className="flex justify-between items-center">
                          <span className="text-[8px] uppercase font-bold text-[#666666] tracking-[1px]">Grossura</span>
                          <span className="text-[10px] text-[#00d9ff] font-bold">{Number(sideChartLineWidth || 1).toFixed(1)}px</span>
                        </div>
                        <input type="range" min="0.5" max="5" step="0.1" value={sideChartLineWidth} onChange={(e) => setSideChartLineWidth(parseFloat(e.target.value))} className="w-full h-1 bg-[#00d9ff]/20 rounded appearance-none cursor-pointer accent-[#00d9ff]" />
                      </div>
                    </div>
                  )}
                </div>

                <div className="border border-white/5 bg-[#0a0e27]/50 rounded-lg p-3 mb-4 shadow-inner">
                  <div className="flex justify-between items-center mb-3">
                    <span className="text-[9px] uppercase tracking-[1px] text-[#666666] font-bold flex-1">Gráfico 2D de Fundo</span>
                    <button onClick={(e) => { e.stopPropagation(); setLockedSliders((p: any) => ({...p, ['box_back']: !(p['box_back'] ?? false)})) }} className="text-[#00d9ff]/50 hover:text-[#00d9ff] focus:outline-none transition-all cursor-pointer">
                      {(lockedSliders['box_back'] ?? false) ? <Lock size={14} /> : <Unlock size={14} />}
                    </button>
                  </div>
                  <div className={cn("space-y-3", (lockedSliders['box_back'] ?? false) && "opacity-50 pointer-events-none")}>
                    <div className="flex justify-between items-center bg-[#0a0e27]/50 border border-[#00d9ff]/30 p-1 rounded-full">
                      <button
                        onClick={() => setBackwallStyle('line')}
                        className={cn(
                          "flex-1 py-1.5 rounded-full text-[10px] uppercase tracking-[1px] transition-all duration-200 cursor-pointer",
                          backwallStyle === 'line' ? "bg-[#00d9ff]/20 text-[#00d9ff] font-bold shadow-[0_0_10px_rgba(0,217,255,0.2)]" : "text-[#666666] hover:text-[#00d9ff]"
                        )}
                      >
                        Linha
                      </button>
                      <button
                        onClick={() => setBackwallStyle('candles')}
                        className={cn(
                          "flex-1 py-1.5 rounded-full text-[10px] uppercase tracking-[1px] transition-all duration-200 cursor-pointer",
                          backwallStyle === 'candles' ? "bg-[#00d9ff]/20 text-[#00d9ff] font-bold shadow-[0_0_10px_rgba(0,217,255,0.2)]" : "text-[#666666] hover:text-[#00d9ff]"
                        )}
                      >
                        Candles
                      </button>
                    </div>
                    <div className="space-y-1">
                      <div className="flex justify-between items-center">
                        <span className="text-[8px] uppercase font-bold text-[#666666] tracking-[1px]">Opacidade</span>
                        <span className="text-[10px] text-[#00d9ff] font-bold">{Math.round(backChartOpacity * 100)}%</span>
                      </div>
                      <input type="range" min="0" max="1" step="0.05" value={backChartOpacity} onChange={(e) => setBackChartOpacity(parseFloat(e.target.value))} className="w-full h-1 bg-[#00d9ff]/20 rounded appearance-none cursor-pointer accent-[#00d9ff]" />
                    </div>
                  </div>
                </div>

                <div className="border border-white/5 bg-[#0a0e27]/50 rounded-lg p-3 mb-4 shadow-inner">
                  <div className="flex justify-between items-center">
                    <div className="flex-1 mr-2">
                      <ToggleSwitch checked={showMidLineWall} onChange={setShowMidLineWall} label="Parede 50%" disabled={lockedSliders['box_midwall'] ?? false} />
                    </div>
                    <button onClick={(e) => { e.stopPropagation(); setLockedSliders((p: any) => ({...p, ['box_midwall']: !(p['box_midwall'] ?? false)})) }} className="text-[#00d9ff]/50 hover:text-[#00d9ff] focus:outline-none transition-all cursor-pointer">
                      {(lockedSliders['box_midwall'] ?? false) ? <Lock size={14} /> : <Unlock size={14} />}
                    </button>
                  </div>
                  {showMidLineWall && (
                    <div className={cn("mt-3 pt-3 border-t border-white/5 space-y-3 animate-in fade-in zoom-in duration-300", (lockedSliders['box_midwall'] ?? false) && "opacity-50 pointer-events-none")}>
                      <div className="flex justify-between items-center">
                        <span className="text-[8px] uppercase font-bold text-[#666666] tracking-[1px]">Cor Parede</span>
                        <div className="flex items-center gap-2">
                          <input 
                            type="color" 
                            value={midLineWallColor} 
                            onChange={(e) => setMidLineWallColor(e.target.value)}
                            className="w-6 h-6 rounded border border-[#00d9ff]/30 bg-transparent cursor-pointer"
                          />
                          <span className="text-[10px] text-[#e0e0e0] font-mono uppercase">{midLineWallColor}</span>
                        </div>
                      </div>
                      <div className="space-y-1">
                        <div className="flex justify-between items-center">
                          <span className="text-[8px] uppercase font-bold text-[#666666] tracking-[1px]">Opacidade</span>
                          <span className="text-[10px] text-[#00d9ff] font-bold">{Math.round(midLineWallOpacity * 100)}%</span>
                        </div>
                        <input 
                          type="range" 
                          min="0" max="1" step="0.01"
                          value={midLineWallOpacity} 
                          onChange={(e) => setMidLineWallOpacity(parseFloat(e.target.value))}
                          className="w-full h-1 bg-[#00d9ff]/20 rounded-lg appearance-none cursor-pointer accent-[#00d9ff]"
                        />
                      </div>
                    </div>
                  )}
                </div>

                {/* Grade & Opacidade (Grid Opacity) */}
                <div className="border border-white/5 bg-[#0a0e27]/50 rounded-lg p-3 mb-4 shadow-inner">
                  <div className="flex justify-between items-center">
                    <div className="flex-1 mr-2">
                      <ToggleSwitch checked={showGrid} onChange={setShowGrid} label="Grade 3D (Grid)" disabled={lockedSliders['box_grid'] ?? false} />
                    </div>
                    <button onClick={(e) => { e.stopPropagation(); setLockedSliders((p: any) => ({...p, ['box_grid']: !(p['box_grid'] ?? false)})) }} className="text-[#00d9ff]/50 hover:text-[#00d9ff] focus:outline-none transition-all cursor-pointer">
                      {(lockedSliders['box_grid'] ?? false) ? <Lock size={14} /> : <Unlock size={14} />}
                    </button>
                  </div>
                  {showGrid && (
                    <div className={cn("mt-3 pt-3 border-t border-white/5 space-y-3 animate-in fade-in zoom-in duration-300", (lockedSliders['box_grid'] ?? false) && "opacity-50 pointer-events-none")}>
                      <div className="flex items-center gap-2">
                        <label className="text-[8px] uppercase font-bold text-[#666666] tracking-[1px] flex-1">Cor da Grade</label>
                        <input 
                          type="color" 
                          value={gridColor} 
                          onChange={(e) => setGridColor(e.target.value)}
                          className="w-6 h-6 rounded cursor-pointer bg-transparent border-0 p-0"
                        />
                        <span className="text-[10px] font-mono text-[#00d9ff] uppercase font-bold">{gridColor}</span>
                      </div>
                      
                      <div className="space-y-1">
                        <div className="flex justify-between items-center">
                          <span className="text-[8px] uppercase font-bold text-[#666666] tracking-[1px]">Opacidade</span>
                          <span className="text-[10px] text-[#00d9ff] font-bold">{Math.round(gridOpacity * 100)}%</span>
                        </div>
                        <input 
                          type="range" 
                          min="0" max="1" step="0.05"
                          value={gridOpacity} 
                          onChange={(e) => setGridOpacity(parseFloat(e.target.value))}
                          className="w-full h-1 bg-[#00d9ff]/20 rounded-lg appearance-none cursor-pointer accent-[#00d9ff]"
                        />
                      </div>
                      
                      <div className="space-y-1 mt-2">
                        <div className="flex justify-between items-center">
                          <span className="text-[8px] uppercase font-bold text-[#666666] tracking-[1px]">Espessura</span>
                          <span className="text-[10px] text-[#00d9ff] font-bold">{Number(gridThickness || 1).toFixed(1)}</span>
                        </div>
                        <input 
                          type="range" 
                          min="0.1" max="5" step="0.1"
                          value={gridThickness} 
                          onChange={(e) => setGridThickness(parseFloat(e.target.value))}
                          className="w-full h-1 bg-[#00d9ff]/20 rounded-lg appearance-none cursor-pointer accent-[#00d9ff]"
                        />
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}

          {/* TAB: ESTUDOS (CHART TOOLS) */}
          {activeSettingsTab === 'estudos' && (
            <div className="space-y-4 animate-in fade-in slide-in-from-bottom-2 duration-200">
              <div className="space-y-4">
                <h2 className="text-[10px] md:text-[11px] uppercase tracking-[2px] text-[#00d9ff] border-b border-[#00d9ff]/20 pb-1">Estudos & Indicadores</h2>
                
                <div className="border border-white/5 bg-[#0a0e27]/50 rounded-lg p-3 space-y-4 shadow-inner">
                  <div className="flex flex-col gap-2">
                    <ToggleSwitch checked={showSMA10} onChange={setShowSMA10} label={`SMA ${sma10Period}`} activeColor="bg-[#facc15]" />
                    {showSMA10 && (
                      <div className="pl-4">
                        <input 
                          type="number" 
                          value={sma10Period} 
                          onChange={(e) => setSma10Period(Math.max(1, parseInt(e.target.value) || 1))}
                          className="bg-black/40 border border-[#facc15]/20 rounded px-2 text-[9px] text-[#facc15] h-6 focus:outline-none focus:border-[#facc15]/50 w-full text-center"
                          placeholder="Period"
                        />
                      </div>
                    )}
                  </div>

                  <div className="flex flex-col gap-2 pt-2 border-t border-white/5">
                    <ToggleSwitch checked={showSMA20} onChange={setShowSMA20} label={`SMA ${sma20Period}`} activeColor="bg-[#38bdf8]" />
                    {showSMA20 && (
                      <div className="pl-4">
                        <input 
                          type="number" 
                          value={sma20Period} 
                          onChange={(e) => setSma20Period(Math.max(1, parseInt(e.target.value) || 1))}
                          className="bg-black/40 border border-[#38bdf8]/20 rounded px-2 text-[9px] text-[#38bdf8] h-6 focus:outline-none focus:border-[#38bdf8]/50 w-full text-center"
                          placeholder="Period"
                        />
                      </div>
                    )}
                  </div>
                  
                  <div className="flex flex-col gap-2 pt-2 border-t border-white/5">
                    <ToggleSwitch checked={showSMA50} onChange={setShowSMA50} label={`SMA ${sma50Period}`} activeColor="bg-[#a855f7]" />
                    {showSMA50 && (
                      <div className="pl-4">
                        <input 
                          type="number" 
                          value={sma50Period} 
                          onChange={(e) => setSma50Period(Math.max(1, parseInt(e.target.value) || 1))}
                          className="bg-black/40 border border-[#a855f7]/20 rounded px-2 text-[9px] text-[#a855f7] h-6 focus:outline-none focus:border-[#a855f7]/50 w-full text-center"
                          placeholder="Period"
                        />
                      </div>
                    )}
                  </div>
                </div>
                <div className="border border-white/5 bg-[#0a0e27]/50 rounded-lg p-3 mb-4 shadow-inner">
                  <div className="flex flex-col gap-2 pt-2 border-t border-white/5">

                  <div className="flex justify-between items-center">
                    <div className="flex-1 mr-2">
                      <ToggleSwitch checked={showConnectors} onChange={setShowConnectors} label="Conexões (Edges)" disabled={lockedSliders['box_connectors'] ?? false} />
                    </div>
                    <button onClick={(e) => { e.stopPropagation(); setLockedSliders((p: any) => ({...p, ['box_connectors']: !(p['box_connectors'] ?? false)})) }} className="text-[#00d9ff]/50 hover:text-[#00d9ff] focus:outline-none transition-all cursor-pointer">
                      {(lockedSliders['box_connectors'] ?? false) ? <Lock size={14} /> : <Unlock size={14} />}
                    </button>
                  </div>
                  {showConnectors && (
                    <div className={cn("flex flex-col gap-2 mt-3 pt-3 border-t border-white/5 animate-in fade-in zoom-in duration-300", (lockedSliders['box_connectors'] ?? false) && "opacity-50 pointer-events-none")}>
                      <div className="flex justify-between items-center">
                        <span className="text-[8px] uppercase font-bold text-[#666666] tracking-[1px]">Opacidade das Conexões</span>
                        <span className="text-[10px] text-[#00d9ff] font-bold">{Math.round((connectorsOpacity || 0) * 100)}%</span>
                      </div>
                      <input 
                        type="range" 
                        min="0" max="1" step="0.05" 
                        value={connectorsOpacity} 
                        onChange={(e) => setConnectorsOpacity(parseFloat(e.target.value))}
                        className="w-full h-1 bg-[#00d9ff]/20 rounded-lg appearance-none cursor-pointer accent-[#00d9ff]"
                      />
                    
                      <div className="space-y-1 mt-2">
                        <div className="flex justify-between items-center">
                          <span className="text-[8px] uppercase font-bold text-[#666666] tracking-[1px]">Espessura</span>
                          <span className="text-[10px] text-[#00d9ff] font-bold">{Number(connectorsThickness || 1).toFixed(1)}</span>
                        </div>
                        <input 
                          type="range" 
                          min="0.1" max="5" step="0.1"
                          value={connectorsThickness} 
                          onChange={(e) => setConnectorsThickness(parseFloat(e.target.value))}
                          className="w-full h-1 bg-[#00d9ff]/20 rounded-lg appearance-none cursor-pointer accent-[#00d9ff]"
                        />
                      </div>
                    </div>
                  )}
                </div>

                <div className="border border-white/5 bg-[#0a0e27]/50 rounded-lg p-3 shadow-inner col-span-2">
                  <div className="flex justify-between items-center">
                    <div className="flex-1 mr-2">
                      <ToggleSwitch checked={showPeriodSeparators} onChange={setShowPeriodSeparators} label="Períodos de Tempo" disabled={lockedSliders['box_periods'] ?? false} />
                    </div>
                    <button onClick={(e) => { e.stopPropagation(); setLockedSliders((p: any) => ({...p, ['box_periods']: !(p['box_periods'] ?? false)})) }} className="text-[#00d9ff]/50 hover:text-[#00d9ff] focus:outline-none transition-all cursor-pointer">
                      {(lockedSliders['box_periods'] ?? false) ? <Lock size={14} /> : <Unlock size={14} />}
                    </button>
                  </div>
                  {showPeriodSeparators && (
                    <div className={cn("flex flex-col gap-2 mt-3 pt-3 border-t border-white/5 animate-in fade-in zoom-in duration-300", (lockedSliders['box_periods'] ?? false) && "opacity-50 pointer-events-none")}>
                      <div className="flex items-center gap-2">
                        <label className="text-[8px] uppercase font-bold text-[#666666] tracking-[1px] flex-1">Cor do Separador</label>
                        <input 
                          type="color" 
                          value={periodColor} 
                          onChange={(e) => setPeriodColor(e.target.value)}
                          className="w-6 h-6 rounded cursor-pointer bg-transparent border-0 p-0"
                        />
                        <span className="text-[10px] font-mono text-[#00d9ff] uppercase">{periodColor}</span>
                      </div>
                      <div className="flex justify-between items-center mt-1">
                        <span className="text-[8px] uppercase font-bold text-[#666666] tracking-[1px]">Opacidade</span>
                        <span className="text-[10px] text-[#00d9ff] font-bold">{Math.round((periodOpacity || 0) * 100)}%</span>
                      </div>
                      <input 
                        type="range" 
                        min="0" max="1" step="0.05" 
                        value={periodOpacity} 
                        onChange={(e) => setPeriodOpacity(parseFloat(e.target.value))}
                        className="w-full h-1 bg-[#00d9ff]/20 rounded-lg appearance-none cursor-pointer accent-[#00d9ff]"
                      />
                      
                      <div className="mt-2 pt-2 border-t border-white/5">
                        <ToggleSwitch checked={showPeriodLabels} onChange={setShowPeriodLabels} label="Etiquetas de Períodos" />
                      </div>
                    </div>
                  )}
                </div>
                </div>
              </div>
            </div>
          )}

          {/* TAB: NUVEM */}
          {activeSettingsTab === 'nuvem' && (
            <div className="space-y-4 animate-in fade-in slide-in-from-bottom-2 duration-200">
              <div className="space-y-3 pb-2">
                <h2 className="text-[10px] md:text-[11px] uppercase tracking-[2px] text-[#00d9ff] border-b border-[#00d9ff]/20 pb-1">Sincronização & Cloud</h2>
                <p className="text-[9px] text-[#8890b0] font-mono leading-relaxed mb-3">
                  Sincronize as preferências de cor, indicadores, amplitude e traçado de zonas com a nuvem do workspace.
                </p>
                
                <div className="flex flex-col gap-2">
                  {user ? (
                    <button
                      onClick={saveSettings}
                      disabled={isSaving}
                      className={cn(
                        "w-full py-2 bg-[#00d9ff]/10 hover:bg-[#00d9ff]/20 text-[#00d9ff] border border-[#00d9ff]/30 rounded uppercase tracking-[1px] text-[10px] md:text-[11px] transition-all font-bold disabled:opacity-50 cursor-pointer",
                        isSaving ? "animate-pulse" : ""
                      )}
                    >
                      {isSaving ? "Salvando..." : "Salvar Configurações (Conta)"}
                    </button>
                  ) : (
                    <button
                      onClick={syncWorkspaceToCloud}
                      disabled={isSaving || !authToken}
                      className={cn(
                        "w-full py-2 bg-[#a855f7]/10 hover:bg-[#a855f7]/20 text-[#a855f7] border border-[#a855f7]/30 rounded uppercase tracking-[1px] text-[10px] md:text-[11px] transition-all font-bold disabled:opacity-50 cursor-pointer",
                        isSaving ? "animate-pulse" : ""
                      )}
                    >
                      {isSaving ? "Sincronizando..." : "Sincronizar Cloud Workspace"}
                    </button>
                  )}
                  
                  {authToken && !user && (
                    <button
                      onClick={loadWorkspaceFromCloud}
                      className="w-full py-2 bg-transparent hover:bg-[#a855f7]/10 text-[#666666] hover:text-[#a855f7] border border-transparent hover:border-[#a855f7]/30 rounded uppercase tracking-[1px] text-[9px] md:text-[10px] transition-all cursor-pointer"
                    >
                      Carregar Cloud Workspace
                    </button>
                  )}
                  
                  <button
                    onClick={resetSettings}
                    className="w-full py-2 bg-transparent hover:bg-[#ff3d67]/10 text-[#666666] hover:text-[#ff3d67] border border-transparent hover:border-[#ff3d67]/30 rounded uppercase tracking-[1px] text-[9px] md:text-[10px] transition-all cursor-pointer"
                  >
                    Redefinir Padrões
                  </button>

                  {saveMessage && (
                    <div className="text-center text-[10px] mt-1 text-[#00ffa3]">{saveMessage}</div>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SettingsSidebar;
